import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getVideoTestimonialContent = createAsyncThunk('/videoTestimonials/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getVideoTestiomonials`, {});
	return response;
})

export const videoTestimonialSlice = createSlice({
    name: 'videoTestimonials',
    initialState: {
        isLoading: false,
        videoTestimonials : []
    },
    reducers: {
    },
    extraReducers: {
		[getVideoTestimonialContent.pending]: state => {
			state.isLoading = true
		},
		[getVideoTestimonialContent.fulfilled]: (state, action) => {
			state.videoTestimonials = action.payload.data
			state.isLoading = false
		},
		[getVideoTestimonialContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default videoTestimonialSlice.reducer